import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import { Tooltip, Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import usePowerBiUrl from '../../../../common/hooks/usePowerBiUrl';
import {
  getProjectSharePointUrl,
  getDocumentPath,
  getProjectSource,
} from '../../../project/projectSlice';
import useMobile from '../../../../common/hooks/useMobile';
import './ViewAnalysisSourceLinks.scss';

const ViewAnalysisSourceLinks = ({ toolTipDirection = 'left' }) => {
  const sharepointUrl = useSelector(getProjectSharePointUrl);
  const documentPath = useSelector(getDocumentPath);
  const projectSource = useSelector(getProjectSource);
  const isMobile = useMobile();
  const linkTitle = projectSource === 'DTP' ? 'dtp' : 'workbench';

  const sharePointJuntion = sharepointUrl
    ? `//${sharepointUrl}/Shared%20Documents/Forms/AllItems.aspx`
    : null;
  const powerBiUrl = usePowerBiUrl();
  const sharePointId = sharepointUrl
    ? sharepointUrl.substr(sharepointUrl.indexOf('/'))
    : null;
  let showWorkbenchLinkTitle = true;
  let toolTipText = 'makeSureYourPowerPoint';
  if (process.env.REACT_APP_TERRITORY === Constants.TERRITORY_CODES.CHINA) {
    showWorkbenchLinkTitle = false;
    toolTipText = 'makeSureYourPowerPointForChina';
  }
  let sharePointLink = sharePointJuntion;

  if (documentPath && sharepointUrl) {
    sharePointLink =
      projectSource === 'Junction' || projectSource === 'DTP'
        ? sharePointJuntion
        : `${sharePointJuntion}?id=${sharePointId}/Shared%20Documents${documentPath}`;
  }
  const { t } = useTranslation();

  return (
    <div className="external-source-links">
      {t('viewIn')}{' '}
      {!!sharePointLink && (
        <a
          className="external-source-link"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="project-sharepoint-link"
          href={sharePointLink}
        >
          {t('sharepoint')}
        </a>
      )}{' '}
      {showWorkbenchLinkTitle && (
        <>
          {t('or')}{' '}
          <a
            className="external-source-link"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="project-workbench-link"
            href={powerBiUrl}
          >
            {t(linkTitle)}
          </a>{' '}
        </>
      )}{' '}
      <Tooltip
        direction={
          isMobile && !showWorkbenchLinkTitle ? 'right' : toolTipDirection
        }
        dataTestId="source-links-tooltip-popup"
        style={{ whiteSpace: 'pre-line' }}
        tip={t(toolTipText)}
      >
        <Icon
          name="information"
          width="16"
          className="icon fill icon-yellow source-file-tooltip-icon"
        />
      </Tooltip>
    </div>
  );
};

export default ViewAnalysisSourceLinks;
